import { ICON_NAME } from "src/_shares/_components/mui-icon/_enums/mui-icon.enum"

export const HEADER_MENU = [
    { path: '/', name: 'Trang chủ' },
    { path: '/hot-sale', name: 'Hot sale' },
    { path: '/new-products', name: 'Sản phẩm mới' },
    { path: '/brands', name: 'Thương hiệu' },
    { path: '/payment', name: 'Thanh toán' },
    { path: '/available-products', name: 'Hàng có sẵn' },
    { path: '/preorder-products', name: 'Hàng đặt trước' },
]
export const FOOTER_MENU_COL_1 = [
    { path: '/about', name: 'Giới thiệu vể công ty' },
    { path: '/blog/1', name: 'Quy tắc đạo đức' },
    { path: '/blog/2', name: 'Quyền riêng tư' },
    { path: '/blog/3', name: 'Sản phẩm của chúng tôi' },
]
export const FOOTER_MENU_COL_2 = [
    { path: '/blog/4', name: 'Chính sách bảo hành' },
    { path: '/blog/5', name: 'Chính sách đổi trả' },
    { path: '/blog/6', name: 'Chính sách thanh toán' },
    { path: '/blog/7', name: 'Chính sách giao hàng' },
]
export const FOOTER_MENU_COL_3 = [
    { path: '/facebook', icon: ICON_NAME.ROUNDED.FACEBOOK, name: 'Facebook' },
    { path: '/youtube', icon: ICON_NAME.YOUTUBE, name: 'Youtube' },
    { path: '/instagram', icon: ICON_NAME.INSTAGRAM, name: 'Instagram' },
    { path: '/messenger', icon: ICON_NAME.MESSENGER, name: 'Messenger' },
]
export const FOOTER_MENU_COL_4 = [
    { path: '/zalo', icon: ICON_NAME.PHONE_ANDROID, name: 'Zalo: 0906035526' },
    { path: '/mail', icon: ICON_NAME.OUTLINED.MAIL, name: 'Mail: vantuanitc1989@gmail.com' },
    { path: '/location', icon: ICON_NAME.OUTLINED.LOCATION, name: 'Số 365/39A Hậu Giang, Phường 11, Quận 06, TP.Hồ Chí Minh' },
    { path: '/time', icon: ICON_NAME.OUTLINED.ACCESS_TIME, name: '08:30 - 17:30' },
]